import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';

/**
 * Selectors for admin UI state
 */

// Base selector for admin UI state
export const selectAdminUI = (state: RootState) => state.adminUI;

// Selector for selected organization ID
export const selectSelectedOrganizationId = createSelector(
  [selectAdminUI],
  (adminUI) => adminUI.selectedOrganizationId
);

// Selector for selected property ID
export const selectSelectedPropertyId = createSelector(
  [selectAdminUI],
  (adminUI) => adminUI.selectedPropertyId
);

// Selector for expanded menu IDs
export const selectExpandedMenuIds = createSelector(
  [selectAdminUI],
  (adminUI) => adminUI.expandedMenuIds
);

// Selector for menu open state
export const selectIsMenuOpen = createSelector(
  [selectAdminUI],
  (adminUI) => adminUI.isMenuOpen
);

// Combined selector for organization and property IDs
export const selectSelectedIds = createSelector(
  [selectSelectedOrganizationId, selectSelectedPropertyId],
  (organizationId, propertyId) => ({
    organizationId,
    propertyId,
  })
);
